// extracted by css-extract-rspack-plugin
export default {"header":"fVXPEifEgV4qGUYK","info":"F8rqy28Qtb8NmLLn"};